import config from '../config';

const network = client => ({
  siteVerify: async ({ response }) => client.post(config().recaptcha.url, { response })
});

export default network;
